import Toaster from './Toaster';

export default Toaster;



// WEBPACK FOOTER //
// ./src/components/Toaster/index.jsx